import { render, staticRenderFns } from "./DigitalHuman.vue?vue&type=template&id=9866c0f0&scoped=true"
import script from "./DigitalHuman.vue?vue&type=script&lang=js"
export * from "./DigitalHuman.vue?vue&type=script&lang=js"
import style0 from "./DigitalHuman.vue?vue&type=style&index=0&id=9866c0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9866c0f0",
  null
  
)

export default component.exports